<template>
    <div class="head">
        <div class="head-btn-group">
            <div :class="`head-btn btn-${i} ${item.value3 ? 'active' : ''}`" v-for="(item, i) in defaultdata" :key="i"
                @click="toother(item)">
                {{ item.value1 }}
            </div>
        </div>
        <div class="head-title">
            <img src="../../assets/j-logo.png" alt="" class="j-logo" v-if="+rolelevel < 2 && !isFirst">
            {{ title }}
        </div>
        <div class="large" @click="screen">
            <img src="@/assets/temimg2/screen.png" alt="">
        </div>
        <div class="head-bg">
            <img src="@/assets/temimg6/head-light.png" alt="">
        </div>
        <el-dialog :visible.sync="dialogVisible" width="715px" :before-close="handleClose" :append-to-body="true"
            custom-class="tem9-log" :close-on-click-modal="false">
            <div class="head-tips">
                导航编辑
            </div>
            <div class="jump-list">
                <div class="jump-item" v-for="(item, i) in loglist" :key="i">
                    <el-input v-model="item.value1" class="jump-input"></el-input>
                    <el-select v-model="item.value2" filterable placeholder="请选择" class="jump-select">
                        <el-option v-for="del in prolist" :key="del.ids" :label="del.name" :value="del.ids">
                        </el-option>
                    </el-select>
                    <el-checkbox v-model="item.value3" class="jump-check" @change="checkchange(i)"></el-checkbox>
                </div>
                <div class="jump-tips">
                    温馨提示：点亮勾代表这块区域高亮展示
                </div>
            </div>
            <div class="tem9-bottom-group">
                <el-button type="primary" size="small" @click="primary">保存</el-button>
                <el-button type="info" plain size="small" @click="handleClose">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment';
import screenfull from 'screenfull'
import { getprolist, getIds } from '@/api/new.js'

export default {
    name: 'headtitle.temhead6',
    props: {
        title: {
            type: String,
            default: '2025年金蝶软件园综合看板'
        },
        vdata: {
            type: [Array, String],
            default: () => []
        },
        rolelevel: {
            type: [String, Number],
            default: -1
        },
        isFirst: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            defaultdata: [
                { value1: '收款业务', value2: '', value3: true },
                { value1: '租赁业务', value2: '', value3: false },
                { value1: '企划看板', value2: '', value3: false },
                { value1: '综合看板', value2: '', value3: false },
            ],
            valuemap: [
                { name: '名称', key: "value1" },
                { name: '跳转项目', key: "value2" },
                { name: '是否高亮', key: "value3" },
            ],
            dialogVisible: false,
            loglist: [],
            prolist: [],
            timer1: null
        }
    },
    watch: {
        vdata(n) {
            this.defaultdata = n
        }
    },
    beforeDestroy() {
        clearTimeout(this.timer1)
        this.timer1 = null
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata
        }
        this.setData()
        this.timer1 = setTimeout(() => {
            let index = this.defaultdata.findIndex(item => item.value3)
            if (index < 3) {
                this.toother(this.defaultdata[index + 1])
            } else {
                this.toother(this.defaultdata[0])
            }
        }, 60000);
    },
    methods: {
        screen() {
            // 如果不允许进入全屏，发出不允许提示
            if (!screenfull.enabled) {
                return false
            }
            screenfull.toggle()
            // this.$message.success("全屏啦")
        },
        handleClose() {
            this.$confirm('是否不保存并关闭当前弹窗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                this.dialogVisible = false
            })
                .catch(() => {

                })
        },
        setData() {
            this.loglist = JSON.parse(JSON.stringify(this.defaultdata))
        },
        getProlist(type, item) {
            const params = {
                page: 1,
                limit: 9999
            }
            getprolist(params).then(res => {
                if (res.status == 200) {
                    this.prolist = res.data
                    if (type == 1) {
                        this.toother(item)
                        return
                    }
                    this.dialogVisible = true
                } else {
                    setTimeout(() => {
                        this.getProlist(type)
                    }, 1000);
                }
            })
        },
        checkchange(index) {
            this.loglist.forEach((item, i) => {
                if (index !== i) {
                    item.value3 = false
                }
            })
        },
        primary() {
            this.defaultdata = JSON.parse(JSON.stringify(this.loglist))
            this.dialogVisible = false
            this.$emit('headsave', this.defaultdata)
        },
        toother(item) {
            var preview = this.$route.query.preview
            let vname = this.$route.name
            if (!preview && vname !== 'share') return
            let proid = this.$route.query.projectId
            if (proid == item.value2) return
            if (!item.value2) {
                this.$message.warning('该页面暂未开放')
                return
            }
            clearTimeout(this.timer1)
            this.timer1 = null
            if (vname == 'share') {
                // this.$message.warning('尝试进行跳转')
                this.$router.push({
                    name: 'share', // 目标路由的名称
                    query: {
                        projectId: item.value2,
                        preview: 1,
                    }
                })
            } else {
                if (!this.prolist.length) {
                    this.getProlist(1, item)
                    return
                }
                let vindex = this.prolist.findIndex(del => del.ids == item.value2)
                if (vindex != -1) {
                    let vid = this.prolist[vindex].id
                    this.$router.push({
                        name: 'editnew', // 目标路由的名称
                        query: {
                            projectId: vid,
                            preview: 1
                        }
                    })
                } else {
                    this.$message.warning('该项目已被移除')
                    return
                }
            }
            // if (vname == 'share') {
            //     getIds({id: item.value2}).then(res => {
            //         if (res.status == 200) {
            //             this.$router.push({
            //                 name: 'share', // 目标路由的名称
            //                 query: {
            //                     projectId: res.data.ids,
            //                     preview: 1,
            //                 }
            //             }).then(() => {
            //                 window.location.reload();
            //             })
            //         } else if (res.status == -1) {
            //             this.$message.warning('该页面暂未开放')
            //             return
            //         }
            //     })
            // } else {
            //     this.$router.push({
            //         name: 'editnew', // 目标路由的名称
            //         query: {
            //             projectId: item.value2,
            //             preview: 1
            //         }
            //     }).then(() => {
            //         window.location.reload();
            //     })
            // }
        },
        openjump() {
            this.getProlist()
        },
    }
}
</script>

<style lang="scss" scoped>
.head {
    width: 1920px;
    height: 121px;
    background: url(@/assets/temimg6/head.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 401;

    .head-title {
        font-family: 'pmzd';
        font-weight: 400;
        color: #FFFFFF;
        // text-shadow: 0px 1px 6px rgba(0,0,0,0.48);
        height: fit-content;
        padding: 8px;
        margin-top: -40px;
        font-size: 40px;
        line-height: 40px;
        text-shadow: 0px 10px 10px rgba(255, 255, 255, 0.69);
        position: relative;
    }
    .j-logo {
        position: absolute;
        width: 60px;
        height: 36px;
        left: -60px;
    }

    .left-timer {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 15px;
        font-style: italic;
        position: absolute;
        left: 64px;
        top: 50px;
        text-shadow: 0 0 10px rgba(41, 81, 202, .8), 0 0 10px rgba(41, 81, 202, .8), 0 0 10px rgba(41, 81, 202, .8);
    }

    .large {
        position: absolute;
        right: 64px;
        top: 42px;
        cursor: pointer;
        pointer-events: auto;

        img {
            width: 46px;
            height: 46px;
        }
    }

    .head-bg {
        width: 685px;
        height: 121px;
        position: absolute;
        animation: light2 2s infinite;

        img {
            width: 100%;
            height: 225px;
        }
    }

    @keyframes light2 {
        0% {
            opacity: 1;
        }

        50% {
            opacity: .5;
        }

        100% {
            opacity: 1;
        }
    }

    .head-btn-group {
        display: flex;
        align-items: center;
        width: 1680px;
        position: absolute;
        top: 18px;

        .head-btn {
            width: 244px;
            height: 59px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 19px;
            color: #fff;
            line-height: 19px;
            cursor: pointer;
            pointer-events: auto;
            opacity: 0.6;
            transition: all 0.5s linear;

            &:hover,
            &.active {
                opacity: 1;
            }

            &.btn-0 {
                background: url(@/assets/temimg6/headleft.png) no-repeat;
                background-size: 100% 100%;
                margin-top: -12px;
            }

            &.btn-1 {
                background: url(@/assets/temimg6/headleft.png) no-repeat;
                background-size: 100% 100%;
                margin-left: -24px;
            }

            &.btn-2 {
                margin-left: auto;
                background: url(@/assets/temimg6/headright.png) no-repeat;
                background-size: 100% 100%;
                margin-right: -24px;
            }

            &.btn-3 {
                background: url(@/assets/temimg6/headright.png) no-repeat;
                background-size: 100% 100%;
                margin-top: -12px;
            }
        }
    }

    .head-select-log {
        position: absolute;
        width: 715px;
        height: 446px;
        background: #181A1B;
        box-shadow: 0px 3px 33px 0px #000000;
        border: 1px solid #3A3B3C;
        z-index: 404;
    }
}
</style>
<style lang="scss">
.tem9-log {
    background: #181A1B;
    box-shadow: 0px 3px 33px 0px #000000;
    border: 1px solid #3A3B3C;
    color: #C0C0C0;
    padding: 34px;
    box-sizing: border-box;

    .head-tips {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #C0C0C0;
        line-height: 18px;
    }

    .jump-list {
        margin-top: 26px;

        .jump-item {
            display: flex;
            align-items: center;

            &+.jump-item {
                margin-top: 16px;
            }
        }

        .jump-input {
            width: 210px;

            .el-input__inner {
                background: #212226;
                border-radius: 4px;
                border: 1px solid #3A3B3C;
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 16px;
                color: #FEFEFE;
                line-height: 16px;
            }
        }
    }

    .jump-select {
        margin-left: 16px;
        width: 340px;

        .el-input__inner {
            background: #212226;
            border-radius: 4px;
            border: 1px solid #3A3B3C;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #FEFEFE;
            line-height: 16px;
        }
    }

    .jump-check {
        margin-left: 36px;
    }

    .el-dialog__header {
        padding: 0;
    }

    .el-dialog__body {
        padding: 0;
    }

    .el-checkbox__inner {
        background: #212226;
        border-radius: 4px;
        border: 1px solid #3A3B3C;
    }

    .jump-tips {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #C0C0C0;
        line-height: 16px;
        margin-top: 26px;
    }

    .tem9-bottom-group {
        display: flex;
        margin-top: 32px;
    }
}

.el-scrollbar__wrap {
    overflow-y: auto;
    overflow-x: hidden;
}
</style>